export default {
    addContactData: '連絡先を追加',
    address: '住所',
    cannotDeleteBecauseOnlyContact:
        'すべての取引先には最低でも一つの連絡先が必要です',
    cannotDeleteBecauseOrganization:
        '複数の連絡先を追加するには組織に所属する必要があります',
    cannotDeleteContact:
        '削除するためにはまず別の住所を記入してください。(※最低1つ)',
    company: '会社',
    defaultContact: 'デフォルトの連絡先',
    deleteContact: '削除',
    department: '部門',
    editContact: '連絡先を編集',
    email: 'Eメール',
    faxNumber: 'FAX番号',
    name: '名前',
    personal: '個人',
    personalTitle: '肩書',
    phoneNumber: '電話番号',
    setAsDefaultContact: 'デフォルトとして設定する',
};
